import { type UnstyledLinkProps } from '@ardoq/link';
import { type OpenEditPriorityFieldsProps } from '@ardoq/component-overview';
import { toLinkProps } from 'router/declarative/toLinkProps';

export const getOpenEditPriorityFieldsLinkProps = (
  componentTypeName: string
): UnstyledLinkProps =>
  toLinkProps({
    route: '/manage-organization/component-overview/:componentTypeName',
    params: { componentTypeName },
  });

type ToOpenEditPriorityFieldsPropsArgs = {
  isAdmin: boolean;
  hasDiscoverInCore: boolean;
  hasPriorityFields: boolean;
  componentTypeName: string;
};

export const toOpenEditPriorityFieldsProps = ({
  isAdmin,
  hasDiscoverInCore,
  hasPriorityFields,
  componentTypeName,
}: ToOpenEditPriorityFieldsPropsArgs): OpenEditPriorityFieldsProps => ({
  shouldShow: isAdmin && hasDiscoverInCore && hasPriorityFields,
  linkProps: getOpenEditPriorityFieldsLinkProps(componentTypeName),
});
